import React, { useState, useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import {
    EuiButtonEmpty,
    EuiFlexItem,
    EuiButtonIcon,
    EuiBasicTable,
    EuiFormRow,
    EuiFieldNumber,
    htmlIdGenerator,
} from '@elastic/eui';
import './style.css';
import KitchenTimePopover from './KitchenTimePopover';
import TimePicker from 'react-time-picker';
import { Controller } from 'react-hook-form';
import moment from 'moment';

const KitchenTimeSlot = ({ setValue, control, name, errors, watch }) => {
    const { fields, append, remove, insert } = useFieldArray({
        control,
        name: name,
    });

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    let columnData = [];
    fields.length &&
        fields.map((field, index) => {
            columnData.push({
                id: field.id,
                start_time: field.start_time,
                end_time: field.end_time,
                preparation_time_in_rush: field.preparation_time_in_rush,
                index: index,
            });
        });

    const columns = [
        {
            field: 'start_time',
            name: 'Start time',
            width: '30%',
            render: (start_time, index) => (
                <>
                    <span>{start_time ? moment(start_time, ['hh:mm']).format('hh:mm a') : ''}</span>
                    <EuiFlexItem style={{ display: 'flex', flexDirection: 'row', display: 'none' }}>
                        <EuiFormRow key={index.id}>
                            <Controller
                                render={({ field }) => (
                                    <TimePicker
                                        value={field.value}
                                        onChange={field.onChange}
                                        onChange={(time) => {
                                            setValue(`${name}[${index.index}].start_time`, time);
                                        }}
                                        format='hh:mm a'
                                        amPmAriaLabel='Select AM/PM'
                                        closeClock={true}
                                        disableClock={true}
                                        required={true}
                                        defaultValue={start_time ? start_time : null}
                                    />
                                )}
                                defaultValue={start_time ? start_time : null}
                                name={`${name}[${index.index}].start_time`}
                                control={control}
                                fullWidth={true}
                            />
                        </EuiFormRow>
                    </EuiFlexItem>
                </>
            ),
        },
        {
            field: 'end_time',
            name: 'End time',
            width: '30%',
            render: (end_time, index) => (
                <>
                    <span>{end_time ? moment(end_time, ['hh:mm']).format('hh:mm a') : ''}</span>
                    <EuiFlexItem style={{ display: 'flex', flexDirection: 'row', display: 'none' }}>
                        <EuiFormRow key={index.id}>
                            <Controller
                                render={({ field }) => (
                                    <TimePicker
                                        value={field.value}
                                        onChange={field.onChange}
                                        onChange={(time) => {
                                            setValue(`${name}[${index.index}].end_time`, time);
                                        }}
                                        format='hh:mm a'
                                        amPmAriaLabel='Select AM/PM'
                                        closeClock={true}
                                        disableClock={true}
                                        required={true}
                                        defaultValue={end_time ? end_time : null}
                                    />
                                )}
                                defaultValue={end_time ? end_time : null}
                                name={`${name}[${index.index}].end_time`}
                                control={control}
                                fullWidth={true}
                            />
                        </EuiFormRow>
                    </EuiFlexItem>
                </>
            ),
        },
        {
            field: 'preparation_time_in_rush',
            name: 'Time(Mins)',
            width: '28%',
            render: (preparation_time_in_rush, index) => (
                <>
                    <span>{preparation_time_in_rush}</span>
                    <EuiFlexItem style={{ display: 'none' }}>
                        <EuiFormRow>
                            <Controller
                                render={({ field }) => (
                                    <EuiFieldNumber
                                        value={field.value}
                                        onChange={field.onChange}
                                        onChange={(e) => {
                                            setValue(
                                                `${name}[${index.index}].preparation_time_in_rush`,
                                                e.target.value
                                            );
                                        }}
                                        placeholder='preparation time'
                                        min={1}
                                        required
                                        defaultValue={preparation_time_in_rush ? preparation_time_in_rush : null}
                                    />
                                )}
                                defaultValue={preparation_time_in_rush ? preparation_time_in_rush : null}
                                name={`${name}[${index.index}].preparation_time_in_rush`}
                                control={control}
                                step='any'
                                fullWidth={true}
                            />
                        </EuiFormRow>
                    </EuiFlexItem>
                </>
            ),
        },
        {
            field: 'remove',
            name: '',
            width: '12%',
            render: (item, index) => (
                <div key={index.id}>
                    <EuiButtonIcon
                        aria-label='button'
                        iconType='minusInCircle'
                        onClick={() => {
                            remove(index.index);
                        }}
                    />
                </div>
            ),
        },
    ];

    const getRowProps = (item) => {
        const { id } = item;
        return {
            'data-test-subj': `row-${id}`,
            className: 'customRowClass',
            onClick: () => {},
            key: item.id,
        };
    };

    const getCellProps = (item, column) => {
        const { id } = item;
        const { field } = column;
        return {
            className: 'customCellClass',
            'data-test-subj': `cell-${id}-${field}`,
            textOnly: true,
        };
    };

    return (
        <>
            <EuiFlexItem style={{ paddingLeft: '10px' }}>
                <EuiBasicTable
                    items={columnData}
                    rowHeader='firstName'
                    columns={columns}
                    rowProps={getRowProps}
                    cellProps={getCellProps}
                />
            </EuiFlexItem>

            <KitchenTimePopover
                button={
                    fields.length < 6 && (
                        <EuiFlexItem
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                paddingLeft: '10px',
                            }}
                        >
                            <EuiButtonEmpty
                                fill
                                iconType='plusInCircleFilled'
                                onClick={() => {
                                    setIsPopoverOpen(true);
                                }}
                            >
                                Add
                            </EuiButtonEmpty>
                        </EuiFlexItem>
                    )
                }
                append={append}
                setIsPopoverOpen={setIsPopoverOpen}
                isPopoverOpen={isPopoverOpen}
            />
        </>
    );
};

export default KitchenTimeSlot;
